var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-10"},[(_vm.selectedTopic === 'correlation')?_c('correlation-data'):(_vm.selectedTopic === 'correlationDischarge')?_c('correlation-discharge-data'):(_vm.selectedTopic === 'sedimentStations')?_c('sediment-stations'):(_vm.selectedTopic === 'inSitu')?_c('in-situ-layer'):_c('h2',[_vm._v(_vm._s(_vm.$t("selectTopic")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }